// src/plugins/filters.js
export default {
    install(app) {
        app.config.globalProperties.$filters = {
            number(val, digits = 2) {
                console.log('format number', val, digits);

                return new Intl.NumberFormat('da-DK', {
                    minimumFractionDigits: digits,
                    maximumFractionDigits: digits
                }).format(val)
            },
            weight(val) {
                return `${val} kg`
            },
            dom(val) {
                return new Date(val).explode().n
            },
            time(val) {
                val = val.toString().substr(0, 19).replace(/ /g, 'T')
                const r = new Date(val).explode()
                return `${r.H}:${r.i}`
            },
            timestamp(value) {
                if (value == null) return ''
                const d = Date.normDate(value)
                return d.format('d-m-Y, kl H:i')
            },
            date(value) {
                if (value == null) return '';
                return app.config.globalProperties.$moment(value).format('YYYY-MM-DD');
            },
            moment(value, format = 'YYYY-MM-DD') {
                return app.config.globalProperties.$moment(value).format(format);
            },
            hours(value) {
                if (typeof value !== 'number' || isNaN(value)) return '';
                // Round to nearest hundredth
                const rounded = Math.round(value * 100) / 100;
                // Format as x,xx (Danish decimal)
                return rounded.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
        }
    }
}